import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { AvatarBase, type AvatarBaseProps } from "@core/ui";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = Omit<AvatarBaseProps, "src" | "renderFallback"> & {
  /** Image source URL */
  image?: string;
  /** Whether the avatar is in loading state */
  isLoading?: boolean;
};

/**
 * Styled avatar component wrapping AvatarBase.
 * Displays a user image or fallback with their initial.
 */
export const Avatar = forwardRef<HTMLDivElement, Props>(
  ({ size = 64, image, isLoading, alt, className, ...props }, ref) => {
    return (
      <AvatarBase
        ref={ref}
        src={image}
        alt={alt}
        size={size}
        className={twMerge(
          "rounded-full overflow-hidden bg-brand-800 flex-shrink-0",
          className
        )}
        imageClassName="w-full h-full object-cover"
        renderFallback={({ alt: fallbackAlt }) => (
          <Type
            variant="h5"
            as="div"
            className="w-full h-full flex items-center justify-center text-brand-50"
          >
            {!isLoading && fallbackAlt ? fallbackAlt.charAt(0).toUpperCase() : ""}
          </Type>
        )}
        {...props}
      />
    );
  }
);

Avatar.displayName = "Avatar";

export default Avatar;

